'use strict';

module.exports = ['$stateProvider', function ($stateProvider) {
    /** Configuro gli endpoint **/

    $stateProvider.state('g-map-index', {
        url: '/g-map',
        template: require('./components/index/index.html'),
        controller: 'gMapIndexCtrl',
        parent:'main'
    });
    
}];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-gMapModule/module-states.js
// module id = 330
// module chunks = 0